// Import model
import { FilterLead2Request } from '../models/FilterLead2Request';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { Lead2Condition } from '../models/Lead2Condition';
import { Lead2Fields } from '../models/Lead2Fields';
import { Lead2IndexedFields } from '../models/Lead2IndexedFields';

// Import dependency serializers (for complex types)
import { Lead2ConditionSerializer } from './Lead2ConditionSerializer';
import { Lead2FieldsSerializer } from './Lead2FieldsSerializer';
import { Lead2IndexedFieldsSerializer } from './Lead2IndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterLead2Request - handles JSON serialization and deserialization with type validation
 */
export class FilterLead2RequestSerializer {
  /**
   * Deserializes a JSON string into a FilterLead2Request instance
   */
  static deserialize(json: string): FilterLead2Request {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterLead2Request instance
   */
  static fromObject(obj: any): FilterLead2Request {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterLead2Request');
    }


    const instance: FilterLead2Request = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as Lead2IndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as Lead2Fields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        Lead2ConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterLead2Request instances
   */
  static deserializeArray(json: string): FilterLead2Request[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterLead2Request instance to a JSON string
   */
  static serialize(instance: FilterLead2Request): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterLead2Request instance to a plain object
   */
  static toObject(instance: FilterLead2Request): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        Lead2ConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterLead2Request instances to a JSON string
   */
  static serializeArray(instances: FilterLead2Request[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
